// extracted by mini-css-extract-plugin
module.exports = {"form-structure-stats":"style_form-structure-stats__GZSkz"};